import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import loadjs from 'loadjs';

import { logout, getToken } from '../_helpers';

class Landing extends Component {
    constructor(props) {
        super(props);
        this.menuRef = React.createRef();
    }
    
    componentDidMount() {
        const scroll = document.querySelectorAll('.deznav-scroll');
        scroll.forEach(el => {
            el.click()
        });
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchstart', this.handleClickOutside);
      }
      
      componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchstart', this.handleClickOutside);
      }
      
      handleClickOutside = (event) => {
        const wrapper = document.getElementById('main-wrapper');
        const menuActive = wrapper && wrapper.classList.contains('menu-toggle');
      
        const isClickInsideMenu = this.menuRef.current && this.menuRef.current.contains(event.target);
        const isNavControl = event.target.closest('.nav-control');
      
        if (menuActive && !isClickInsideMenu && !isNavControl) {
          this.onBackClick();
        }
      };


    componentWillMount() {
        loadjs(
            [
                '/vendor/global/global.min.js',
                '/vendor/jquery-nice-select/js/jquery.nice-select.min.js',
                '/js/custom.min.js',
                '/js/deznav-init.js',
                '/vendor/bootstrap/js/bootstrap.bundle.min.js',
            ],
            { async: false }
        );
    }

    onBackClick = () => {
        const wrapper = document.getElementById('main-wrapper');
        if (wrapper) wrapper.classList.toggle('menu-toggle');

        const hamburger = document.querySelectorAll('.hamburger');
        hamburger.forEach(el => el.classList.toggle('is-active'));

        const navback = document.querySelector('.nav-back');
        if (navback) {
            navback.classList.toggle('fixed');
            navback.classList.toggle('absolute');
        }
    };

    SmartLink = ({ to, children, ...rest }) => {
        let touchStart = null;
        const handleTouchStart = (e) => {
            touchStart = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY,
                time: Date.now()
            };
        };

        const handleLinkClick = (to, e) => {
            if (touchStart) {
                const touchEnd = {
                    x: e.changedTouches?.[0]?.clientX || e.clientX,
                    y: e.changedTouches?.[0]?.clientY || e.clientY,
                    time: Date.now()
                };
    
                const distance = Math.sqrt(
                    Math.pow(touchEnd.x - touchStart.x, 2) + 
                    Math.pow(touchEnd.y - touchStart.y, 2)
                );
    
                if (distance > 10 || (touchEnd.time - touchStart.time) > 500) {
                    e.preventDefault();
                    touchStart = null;
                    return;
                }
            }


            e.preventDefault();
            if (window.location.pathname === to) {
                setTimeout(this.onBackClick, 0);
            } else {
                this.props.history.push(to);
            }
        };

        return <Link
            to={to}
            onTouchStart={handleTouchStart} 
            onTouchEnd={(e) => handleLinkClick(to, e)}
            onClick={(e) => {
                if (window.location.pathname === to) {
                    e.preventDefault();
                    setTimeout(this.onBackClick, 0);
                }
            }}
            {...rest}
            
        >
            {children}
        </Link>
    }

    render() {
        const SmartLink = this.SmartLink;

        const loginRegLink = (
            <ul className="navbar-nav">
                <li className="nav-item">
                    <SmartLink to="/login" className="nav-link">
                        Login
                    </SmartLink>
                </li>
                <li className="nav-item">
                    <SmartLink to="/register" className="nav-link">
                        Register
                    </SmartLink>
                </li>
            </ul>
        );

        const userLink = (
            <ul className="metismenu" id="menu">
                <li>
                    <a className="has-arrow ai-icon" aria-expanded="false">
                        <i className="fa fa-house-user"></i>
                        <span className="nav-text">Properties</span>
                    </a>
                    <ul aria-expanded="false">
                        <li><SmartLink to="/properties" className='nav-link'>Property List</SmartLink></li>
                        <li><SmartLink to="/properties/add" className='nav-link'>Add Property</SmartLink></li>
                    </ul>
                </li>
                <li>
                    <SmartLink to="/reservation" className='nav-link'>
                        <i className="flaticon-381-list"></i>
                        <span className="nav-text">Reservation</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/booking/availability" className='nav-link'>
                        <i className="fa fa-calendar"></i>
                        <span className="nav-text">Booking Calendar</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/custom/dashboard" className='nav-link'>
                        <i className="fa fa-bell"></i>
                        <span className="nav-text">Dashboard</span>
                    </SmartLink>
                </li>
                <li>
                    <a className="has-arrow ai-icon" aria-expanded="false">
                        <i className="fa fa-balance-scale"></i>
                        <span className="nav-text">Dispute</span>
                    </a>
                    <ul aria-expanded="false">
                        <li><SmartLink to="/dispute/list" className='nav-link'>Dispute List</SmartLink></li>
                    </ul>
                </li>
                <li>
                    <SmartLink to="/review"  className='nav-link'>
                        <i className="fa fa-star"></i>
                        <span className="nav-text">Review</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/messages" className='nav-link'>
                        <i className="fa fa-comment"></i>
                        <span className="nav-text">Message</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/profile" className='nav-link'>
                        <i className="fa fa-user"></i>
                        <span className="nav-text">Profile</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/subscription" className='nav-link'>
                        <i className="fa fa-sync"></i>
                        <span className="nav-text">Subscription</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/setting/payout-method" className='nav-link'>
                        <i className="fa fa-credit-card"></i>
                        <span className="nav-text">Payout Method</span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/faq" className='nav-link'>
                        <i className="flaticon-050-info"></i>
                        <span className="nav-text">FAQ </span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/contact" className='nav-link'>
                        <i className="flaticon-381-smartphone-5"></i>
                        <span className="nav-text">Contact </span>
                    </SmartLink>
                </li>
                <li>
                    <SmartLink to="/" onClick={() => logout()} className='nav-link'>
                        <i className="fa fa-sign-out-alt"></i>
                        <span className="nav-text">Logout</span>
                    </SmartLink>
                </li>
            </ul>
        );

        return (
            <>
                <div ref={this.menuRef} className="deznav-scroll" style={{zIndex: 999}}>{getToken() ? userLink : loginRegLink}</div>
                {/* <div className="nav-back absolute mobile-nav-back" style={{backgroundColor: 'red'}} onClick={this.onBackClick}/> */}
            </>
        );

    }
}

export default withRouter(Landing);
